<template>
	<div class="view-index-h">
		<div class="echart-wrapper">
			<div ref="echart" class="echart"></div>
		</div>
		<div class="project-list">
			<div class="project-item" v-for="(item, idx) in listData" :key="idx" @click="onClickItem(item.id)">
				<div class="project-main">
					<img :src="item.coverImgUrl" class="project-img" />
					<div class="inf-container">
						<div class="name single-line">项目名称:{{item.projectName}}</div>
						<div class="location single-line">项目位置:{{getProjectLocation(item)}}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <copy-right /> -->
		<div class="pop-list" :style="popListStyle" @mousemove="onHoldPopList" @mouseleave="onChartUnPopList">
			<img class="bg" :style="popBgStyle" src="~@/assets/png/pop-bg.png" />
			<div class="list-wrapper">
				<div class="item-wrapper" v-for="(item, idx) in popListItems" :key="idx"  @click="onClickItem(item.id)">
					<img :src="item.coverImgUrl" class="project-img" />
					<div class="inf-container">
						<div class="name single-line">项目名称:{{item.projectName}}</div>
						<div class="location single-line">项目位置:{{getProjectLocation(item)}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'IndexH',
		mixins: [IndexMixin],
		components: {
			CopyRight
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.view-index-h {
		width: 100%;
		padding-left: calc(75px * var(--scale-rate));
		position: relative;
		
		.echart-wrapper {
			width: 100%;
			height: 0;
			padding-top: 33.33%;
			position: relative;
			overflow: hidden;
			.echart {
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				position: absolute;
			}
		}
		
		.project-list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-top: calc(25px * var(--scale-rate));
			
			.project-item {
				width: 33%;
				padding: calc(20px * var(--scale-rate)) calc(57px * var(--scale-rate));
				cursor: pointer;
				
				.project-main {
					width: 100%;
					height: 0;
					padding-top: 66.6666667%;
					position: relative;
					
					.project-img {
						position: absolute;
						top: 0;
						height: 0;
						width: 100%;
						height: 100%;
						object-fit: fill;
					}
					.inf-container {
						width: calc(100% / var(--scale-rate));
						height: 52px;
						background-color: rgba(58, 58, 61, 0.58);
						position: absolute;
						bottom: calc(8px * var(--scale-rate));
						color: #FFFFFF;
						transform: scale(var(--scale-rate));
						transform-origin: 0 100%;
						padding-left: 15px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: flex-start;
						.name {
							font-size: 15px;
							width: 100%;
						}
						.location {
							font-size: 15px;
							width: 100%;
						}
					}
				}
			}
		}
	}
</style>